import { render, staticRenderFns } from "./PasswordResetSelector.vue?vue&type=template&id=76dd5190&"
import script from "./PasswordResetSelector.vue?vue&type=script&lang=babel&"
export * from "./PasswordResetSelector.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports